import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "krefield-switch",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <nz-switch nzDisabled="true"></nz-switch>
      </div>
    </ng-container>
    <ng-template #other>
      <nz-switch
        [formControl]="formControl"
        [kreFormAttributes]="field"
        [class.is-invalid]="showError"
        [nzDisabled]="!editor"
      ></nz-switch>
    </ng-template>
  `,
})
export class KreFormFieldSwitch extends FieldType {
  // switchValue(): string {
  //   if (!!this.model[this.field.key]) {
  //     return "是";
  //   } else {
  //     return "否";
  //   }
  // }
}
